import { Nav, Container, Row, Col, Tab, Carousel } from "react-bootstrap";
import { useState } from "react";
import { ProjectCard } from "./ProjectCard";
import { CertCard } from "./CertCard";
import { motion } from "framer-motion";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import certImg1 from"../assets/img/cert-img1.png";
import certImg2 from"../assets/img/cert-img2.png";
import certImg3 from"../assets/img/cert-img3.png";
import certImg4 from"../assets/img/cert-img4.png";
import certImg5 from"../assets/img/cert-img5.png";
import certImg6 from"../assets/img/cert-img6.png";
import certImg7 from"../assets/img/cert-img7.png";
import colorSharp2 from "../assets/img/color-sharp2.png";

// make motion versions of bootstrap components
const MotionCol = motion(Col);

export const Projects = () => {
    const [activeProjectPage, setActiveProjectPage] = useState(0);
    const [activeCertPage, setActiveCertPage] = useState(0);

    const itemsPerPage = 6;

    const projects = [
        {
            title: "GeneGuard",
            description: "Hackathon Project",
            imgUrl: projImg1,
            projectUrl: "https://geneguard.vercel.app/", 
            isExternal: true
        },
        {
            title: "TESTING 2",
            description: "Design & Development",
            imgUrl: projImg2,
            projectUrl: "", 
            isExternal: true
        },
        {
            title: "TESTING 3",
            description: "Design & Development",
            imgUrl: projImg3,
            projectUrl: "", 
            isExternal: true
        }
    ]

    const certificates = [
        {
            title: "CompTIA Security+",
            description: "CompTIA Security+ is a globally recognized certification that validates essential, hands-on skills for securing networks, applications, and devices. It demonstrates a strong foundation in protecting data and managing real-world security challenges, making it a valuable credential for advancing in cybersecurity careers.",
            imgUrl: certImg6,
        },
        {
            title: "Building Transformer-Based NLP Applications",
            description: "Build and fine-tune Transformer models in PyTorch to create a named-entity recognition application with BERT and deploy it using ONNX, TensorRT, and Triton for efficient NLP inference",
            imgUrl: certImg1,
        },
        {
            title: "Generative AI with Diffusion Models",
            description: "Build and train diffusion generative models using U-Nets, denoising processes, and CLIP to create images from noise and generate text-guided visuals for modern text-to-image applications",
            imgUrl: certImg2,
        },
        {
            title: "Building RAG Agents with LLMs",
            description: "Build and deploy a RAG (Retrieval-Augmented Generation) chatbot that uses NVIDIA AI models to answer questions by retrieving relevant information from research papers stored in a vector database",
            imgUrl: certImg4,
        },
        {
            title: "Applications of AI for Anomaly Detection",
            description: "Build and deploy AI-powered anomaly detection models using XGBoost, autoencoders, and GANs to automatically identify abnormal patterns in data streams and predict potential threats across cybersecurity, finance, and industrial systems",
            imgUrl: certImg5,
        },
        {
            title: "Building Agentic AI Applications with Large Language Models",
            description: "This course teaches you to build AI agents that perform research, use tools, and execute complex tasks using structured outputs, retrieval systems, and multi-agent orchestration with LangGraph.",
            imgUrl: certImg7,
        },
        {
            title: "Microsoft Office Specialist",
            description: "Advanced proficiency in Excel, Word, and PowerPoint applications",
            imgUrl: certImg3,
        },               
    ]

    const projectPages = [];
    for (let i = 0; i < projects.length; i += itemsPerPage) {
        projectPages.push(projects.slice(i, i + itemsPerPage));
    }

    const certPages = [];
    for (let i = 0; i < certificates.length; i += itemsPerPage) {
        certPages.push(certificates.slice(i, i + itemsPerPage));
    }    

    const prefersReduced = typeof window !== "undefined" &&
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const container = {
        hidden: { 
            opacity: 0, 
            y: prefersReduced ? 0 : 30 
        },
        show: {
            opacity: 1,
            y: 0,
            transition: { 
                type: "spring", 
                stiffness: 80, 
                damping: 14, 
                mass: 0.6,
                staggerChildren: 0.08, 
                delayChildren: 0.05, 
            },
        },
    };

    const item = {
        hidden: {
            opacity: 0,
            y: prefersReduced ? 0 : 28
        },
        show: {
            opacity: 1, 
            y: 0,
            transition: {
                type: "spring",
                stiffness: 85,
                damping: 14,
                mass: 0.6
            },
        },
    };

    return (    
        <section className="project" id="project">
            <Container>
                <Row>
                    <Col>
                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.25 }}
                        variants={container}
                        style={{ willChange: "transform" }}
                    >
                    
                    <h2>Projects & Certifications</h2>
                    <p>Recent Projects & Certifications</p>

                    <Tab.Container id="projects-tab" defaultActiveKey="first">
                        <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                            <Nav.Item>
                                <Nav.Link eventKey="first">Projects</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second">Certifications</Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content mountOnEnter unmountOnExit>
                            <Tab.Pane eventKey="first">
                                {projectPages.length > 1 ? (
                                    <Carousel
                                        activeIndex={activeProjectPage}
                                        onSelect={setActiveProjectPage}
                                        indicators={true}
                                        interval={null}
                                        className="project-carousel"
                                    >
                                        {projectPages.map((page, pageIndex) => (
                                            <Carousel.Item key={pageIndex}>
                                                <motion.div 
                                                    variants={container}
                                                    initial="hidden"
                                                    animate="show"
                                                    style={{ willChange: "transform" }}
                                                >
                                                    <Row className="g-4 align-items-stretch">
                                                        {page.map((project, index) => (
                                                            <MotionCol 
                                                                key={index}
                                                                xs={12}
                                                                sm={6}
                                                                lg={4}
                                                                variants={item}
                                                                className="h-100"
                                                                style={{ willChange: "transform" }}
                                                            >
                                                                <ProjectCard {...project} />
                                                            </MotionCol>
                                                        ))}
                                                    </Row>
                                                </motion.div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                ): (
                                    <motion.div
                                        variants={container}
                                        initial="hidden"
                                        whileInView="show"
                                        viewport={{ once: false, amount: 0.2 }}
                                        style={{ willChange: "transform" }}
                                    >
                                        <Row className="g-4 align-items-stretch">
                                            {projects.map((project, index) => (
                                                <MotionCol
                                                    key={index}
                                                    xs={12}
                                                    sm={6}
                                                    lg={4}
                                                    variants={item}
                                                    className="h-100"
                                                    style={{ willChange: "transform" }}
                                                >
                                                    <ProjectCard {...project} />
                                                </MotionCol>
                                            ))}
                                        </Row>
                                    </motion.div>
                                )}
                            </Tab.Pane>

                            <Tab.Pane eventKey="second">
                                {certPages.length > 1 ? (
                                    <Carousel
                                        activeIndex={activeCertPage}
                                        onSelect={setActiveCertPage}
                                        indicators={true}
                                        interval={null}
                                        className="project-carousel"
                                    >
                                        {certPages.map((page, pageIndex) => (
                                            <Carousel.Item key={pageIndex}>
                                                <motion.div 
                                                    variants={container}
                                                    initial="hidden"
                                                    animate="show"
                                                    style={{ willChange: "transform" }}
                                                >
                                                    <Row className="g-4 align-items-stretch">
                                                        {page.map((cert, index) => (
                                                            <MotionCol 
                                                                key={index}
                                                                xs={12}
                                                                sm={6}
                                                                lg={4}
                                                                variants={item}
                                                                className="h-100"
                                                                style={{ willChange: "transform" }}
                                                            >
                                                                <CertCard {...cert} />
                                                            </MotionCol>
                                                        ))}
                                                    </Row>
                                                </motion.div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                ): (
                                    <motion.div
                                        variants={container}
                                        initial="hidden"
                                        whileInView="show"
                                        viewport={{ once: false, amount: 0.2 }}
                                        style={{ willChange: "transform" }}
                                    >
                                        <Row className="g-4 align-items-stretch">
                                            {certificates.map((cert, index) => (
                                                <MotionCol
                                                    key={index}
                                                    xs={12}
                                                    sm={6}
                                                    lg={4}
                                                    variants={item}
                                                    className="h-100"
                                                    style={{ willChange: "transform" }}
                                                >
                                                    <CertCard {...cert} />
                                                </MotionCol>
                                            ))}
                                        </Row>
                                    </motion.div>
                                )}
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                    </motion.div>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2} alt=""/>
        </section>
    )
}